type Direction = 'down' | 'left'

type CoordinateSystem = 'clientX' | 'clientY'

type Constructor = {
  distance: number
  direction: Direction
  onTouchEnd: Function
}

const coordinateSystemMap: Record<Direction, CoordinateSystem> = {
  left: 'clientX',
  down: 'clientY',
}

export class TouchService {
  private startPosition = 0
  private endPosition = 0
  private readonly coordinateSystem: CoordinateSystem
  private readonly distance: number
  private readonly direction: Direction
  private readonly onTouchEnd: Function

  /**
   * Сервис для обработки касаний экрана для touch устройств
   * @param distance - Расстояние между начальной и конечной позицей касания экрана для срабатывания колбэка
   * @param direction - Направление движение свайпа для срабатывания колбэка
   * @param onTouchEnd - Функция, которая выполнится при пройденной дистанции
   */
  constructor({ distance, direction, onTouchEnd }: Constructor) {
    this.distance = distance
    this.direction = direction
    this.onTouchEnd = onTouchEnd
    this.coordinateSystem = coordinateSystemMap[direction]
  }

  // Устанавливаем позицию равную началу касания экрана
  onStart(event: TouchEvent) {
    if (!event.touches?.length) return

    this.startPosition = event.touches[0][this.coordinateSystem]
  }

  // Устанавливаем конечную позицию касания экрана
  onMove(event: TouchEvent) {
    if (!event.touches?.length) return

    this.endPosition = event.touches[0][this.coordinateSystem]
  }

  // При завершении касаний, сравниваем пройденное расстояние между касаниями и высчитываем разницу
  onEnd() {
    let delta = 0

    if (this.direction === 'down') delta = this.endPosition - this.startPosition

    if (this.direction === 'left') delta = this.startPosition - this.endPosition

    if (this.endPosition > 0 && delta >= this.distance) this.onTouchEnd()

    this.startPosition = 0
    this.endPosition = 0
  }
}
